import { render, staticRenderFns } from "./AppHome.vue?vue&type=template&id=207ad70a&scoped=true"
import script from "./AppHome.vue?vue&type=script&lang=js"
export * from "./AppHome.vue?vue&type=script&lang=js"
import style0 from "./AppHome.vue?vue&type=style&index=0&id=207ad70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ad70a",
  null
  
)

export default component.exports